export default __webpack_public_path__ + "static/media/header-hamburger-active.500cd3ff.svg";